//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import photoCode from '@/components/code/index'
import { index, getValiCode, fourEleCheck, businessVerifyHandler, pageDetailLoad} from "@/assets/api/dataBase.js";
import {utils} from "@/assets/utils/utils.js";
import vPinyin from '@/assets/utils/vue-py.js';
// import provinceBankJson from '@/assets/api/bank.json'
import dbmap from "@/assets/dbs/hashmap.js"
import Alert from '@/components/alert/index'
import axios from 'axios'
import text from '@/assets/api/text.json'

export default {
    components:{
        photoCode,
        Alert
    },
    data () {
        return {
            isChannelAgent: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt:'waring',//负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            lastNameText: '姓名不能为空！',
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg:'waring',
            sendInfo:{
                bankCode: dbmap.get('bankCode'),

                verifyCode:'', //验证码

                gender: '', //性别
                channelAgent: '', //客户经理推荐号
                // caUser:'', // 客户推荐手机号
                corpName: '',//借款人经营主体
                productCode: dbmap.get('productCode'), //贷款产品
                loanAmt: '', //贷款额度

                userNamePY: '', //姓名（拼音）
                userName:'', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName:'', // 名

                idCardNum:'', //身份证号码
                bankNum:'', // 银行卡
                mobile:'',//手机号
                stream: dbmap.get('stream') ? dbmap.get('stream') : '',


            },
            //倒计时
            isSendPhone: false,
            isSendCode: true,//发送验证码按钮不可点击样式
            hint:'发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode:dbmap.get('productCode'),
                bankCode: dbmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo:{
                checked01: false,
                checked02: false,
                checked07: false,
                checked08: false,
                checked09: false,
                checked10: false,
                
                // checked03: false,
            },
            isCheckBox: false,
            isChecked: false,
            isCheckedp: false, // 个人选中
            isLoanAmt:false,
            lastNEng: "",
            firstNEng: "",
           
            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode:"",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode:false,
            // 小微贷款修改---
            textList:[],
            productCode:localStorage.getItem('productCode'),
            corpNameTxt:"waring",
            iscorpName:false,
            loanAmtTxt:"",
        }
    },
    mounted(){
        // this.inif()
        this.getImage();
    },
    created(){
        // this.provinceBankJson = provinceBankJson
        text.map((item, index) => {
            if(this.productCode === item.code){
                this.textList = item
                return
            }
            return
        });
        console.log(this.textList);
    },
    methods: {

        inif(){
            pageDetailLoad({'fbCode':'0016'}).then(result => {
                if (result.responseCode === "000000") {
                    let responseData = result.responseData
                    dbmap.set('application_id',responseData.loanOrderCode)
                    this.sendInfo.bankNum = responseData.cardNum || ''
                    this.sendInfo.mobile = responseData.mobile || ''

                    this.sendInfo.lastName = responseData.lastName || ''
                    this.sendInfo.firstName = responseData.firstName || ''
                    this.sendInfo.lastNameEng = responseData.lastNameEng || ''
                    this.sendInfo.firstNameEng = responseData.firstNameEng || ''

                }
            })
          
        },
        // 获取图形验证码
        getImage(){
           let url =  process.env.BASE_API2 +'image/signCaptcha'

            axios({
                method: 'post',
                url: url,
                data: {}
            }).then(result=>{
                console.log('result',result);
                this.imgSrc = result.data.responseData.verCode;
                this.uuId = result.data.responseData.uuId;
            })
        },
        verCodeChange(){
            if(this.verCode != ""){
                this.isVerCodeError = false
                this.getCursorCode  = false
            }else{
                this.isVerCodeError = true
                this.getCursorCode = true
                this.isBindPhotoError = false
                this.isAllSuccess()
            }
        },
        // 贷款额度
        loanAmtVal(e){
            if(e.target){
                this.sendInfo.loanAmt = e.target.value
            }

            this.isLoanAmt = true;

           if( Number(this.sendInfo.loanAmt) >2000){
                this.sendInfo.loanAmt = ''
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能大于2000万元'
                return;
            }else if(Number(this.sendInfo.loanAmt) < 0){
                this.sendInfo.loanAmt = ''
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能小于0'
                return;
            }else if(this.sendInfo.loanAmt === ''){
                console.log('请填写需要申请的贷款额度');
                this.isLoanAmt = true;
                this.loanAmtTxt = '请填写需要申请的贷款额度'
                this.isAllSuccess()
                return;
            }

            this.isLoanAmt = false;
            this.loanAmtTxt = 'waring';
            this.isAllSuccess()


        },
        btnBack(){
            this.$router.push({
                path:"/index"
            });
            return false;
        },
        //验证码
        getPhotoCode(val){
           this.sendInfo.verifyCode = val
        },
        //姓名校验
        verNamePY(){
            this.isUserNamePY = true;
            if(!this.sendInfo.firstNameEng){
                this.isAllSuccess()
                return
            }
            this.isUserNamePY = false;
            this.isAllSuccess()
        },
        verlastNamePY(){
            this.isUserNamePY = true;
            if(!this.sendInfo.lastNameEng){
                this.isAllSuccess()
                return
            }
            this.isUserNamePY = false;
            this.isAllSuccess()
        },
        verlastName(){
            let reg = /^[\u4e00-\u9fa5]+$/
            if( this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)){
                this.lastNameText = '姓名请输入中文！'
                this.isUserName = true;
            }else{
                if(!this.sendInfo.lastName){
                    this.isAllSuccess()
                    this.verlastNamePY()
                    return
                }
                let PinYin = vPinyin.chineseToPinYin(this.sendInfo.lastName);
                if(this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng==this.lastNEng){
                    this.sendInfo.lastNameEng = PinYin
                }
                if(reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)){
                    this.isUserName = false;
                }
                this.isAllSuccess()
                this.verlastNamePY()
                this.lastNEng = PinYin
            }

        },
        verName(){

            let reg = /^[\u4e00-\u9fa5]+$/
            if( this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)){
                this.lastNameText = '姓名请输入中文！'
                this.isUserName = true;
            }else{
                this.isUserName = true;
                if(!this.sendInfo.firstName){
                    this.isAllSuccess()
                    this.verNamePY()
                    return;
                }
                let PinYin = vPinyin.chineseToPinYin(this.sendInfo.firstName);
                if(this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng==this.firstNEng){
                    this.sendInfo.firstNameEng = PinYin
                }

                if(reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)){
                    this.isUserName = false;
                }
                this.isAllSuccess()
                this.verNamePY()
                this.firstNEng = PinYin
            }


        },
       
        vercorpName(e){
            if(e.target){
                this.sendInfo.corpName = e.target.value
            }
            this.iscorpName = true;
            if(this.sendInfo.corpName === ''){
                this.corpNameTxt = '请填写借款申请主体名称'
                this.isAllSuccess()
                return;
            }
            this.iscorpName = false;
            this.corpNameTxt = 'waring';
            this.isAllSuccess()
        },
      
        // 验证手机号码
        verMobilePhone(e){
            if(e.target){
                this.sendInfo.mobile = e.target.value
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            let reg=11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if(this.sendInfo.mobile==''){
                this.bindPhotoTxt = '手机号码不能为空！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }else if(this.sendInfo.mobile && this.sendInfo.mobile.length < 11){
                this.bindPhotoTxt = '手机号码位数不够！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }else if(!reg.test(this.sendInfo.mobile)){
                this.bindPhotoTxt = '手机号码格式有误！'
                this.isSendPhone = false;
                this.isAllSuccess()
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess()
        },
        //获取验证码
        getVerifyCode() {
            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode =  this.verCode;
            this.valiCodeParams.uuId =  this.uuId;
            getValiCode(this.valiCodeParams).then(result => {
                if(result.responseCode === "000000"){

                    this.isDisabled = false;
                    
                    //开始倒计时
                    this.countdownTime();

                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                }else if (result.responseCode == "000405") {
                    this.isVerCodeError = true;
                    this.isDisabled = true;
                    this.isAllSuccess();
                    this.verCodeErrorText = result.responseMessage;
                }
            })
        },
        // 倒计时 方法
        countdownTime() {
            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.isSendPhone = true
                this.isSendCode = true;
                this.imageValidCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(() => {
                    if (
                        this.countdown.count > 0 &&
                        this.countdown.count <= this.countdown.TIME_COUNT
                    ) {
                        this.countdown.counts = '重发验证码（'+this.countdown.count + "s）";
                        this.countdown.count--;
                    } else {
                        clearInterval(this.countdown.timer);
                        this.imageValidCode = false;
                        this.getCursorCode = false;
                        this.countdown.timer = null;
                        this.countdown.counts = this.hint;
                        this.isSendPhone = false
                        this.isSendCode = false;
                    }
                }, 1000);
            }
        },
        //验证码校验
        verPhotoCode(){
            if(this.sendInfo.verifyCode.length !== 6){
                this.photoCodeBool = true
                this.isBindPhotoError = true
                this.toastMsg = '验证码位数不够！'
                this.isAllSuccess()
                return false
            }else{
                this.photoCodeBool = false
                this.isBindPhotoError = false
                this.toastMsg = 'waring'
                this.isAllSuccess()
            }
        },

        //四要素认证
        callFourEleCheck(){
            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC'
            this.sendInfo.appName = "00PACIFIC"

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            let capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            let ret = "";
            for (var i = 0; i < capital.length; i++) {
                let c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret

            // this.sendInfo.type1012 = this.verNoticeInfo.checked07
            this.sendInfo.type1013 = this.verNoticeInfo.checked08
            this.sendInfo.type1014 = this.verNoticeInfo.checked09
            this.sendInfo.type1015 = this.verNoticeInfo.checked10
        

            dbmap.set('sendInfo',this.sendInfo)
            console.log('sendInfo------------',this.sendInfo);
            fourEleCheck(this.sendInfo).then(result => {
                this.isBindPhotoError = false
                this.isAllRrquridSuccess = false
                if (result.responseCode === "000000") {
                    dbmap.set('application_id',result.responseData.loanOrderCode)
                    let fbCode = result.responseData.fbCode
                    let fbMessage = result.responseData.fbMessage
                    let loginName = result.responseData.loginName || ''
                    let retryBtn = result.responseData.retryBtn || ''
                    let messageInfo = utils.routerJump.returnUrl(fbCode);
                    let url = messageInfo.url
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    this.$router.push({
                        path:url,
                        query:{
                            code:fbCode,
                            fbMessage:fbMessage,//认证失败还有所少次变化 后端返回
                            retryBtn:retryBtn,// '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName:loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    })
                }else if(result.responseCode === "000405"){
                    this.isBindPhotoError = true;
                    this.toastMsg = result.responseMessage;
                    this.isAllRrquridSuccess = true

                    window.scrollTo(0, 0);
                }
            });
        },
        // 下一步
        pass(){
            console.log(this.sendInfo);
            this.isAllRrquridSuccess = false
            this.verlastName()
            this.verName()
            this.verlastNamePY()
            this.verNamePY()
            this.verMobilePhone(1)
            this.verPhotoCode()
            this.vercorpName(1)
            this.verNoticeBox()
            this.loanAmtVal(1)

            let statusInfo = this.isAllSuccess()
            if(!statusInfo){
                this.callFourEleCheck()
            }else{
                window.scrollTo(0, 0);
            }
        },
    
        isAllSuccess(){
            if( !this.isCheckBox && !this.isChecked  && !this.isUserName && !this.isUserNamePY
                 && !this.isBindPhoto && !this.isBindPhotoError  &&  !this.isVerCodeError && !this.isLoanAmt && !this.iscorpName){
                this.isAllRrquridSuccess = false
                return false
            }else{
                this.isAllRrquridSuccess = true
                return true
            }
        },
        spaceEvent(e){
            e.currentTarget.previousElementSibling.focus()
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },
        keyEvent(e){
            if([37,38,39,40].indexOf(e.keyCode) > -1){
                let a
                if(e.currentTarget.previousElementSibling.value == '01'){
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0]
                }else{
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0]
                }
                    a.focus()
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            }else{
                return 
            }
        },
        // 授权
        spaceEventCheckBox(e){
            e.currentTarget.previousElementSibling.focus()
            let aa = e.currentTarget.previousElementSibling.name
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa]
        },
        //认证须知校验
        verNotice(){
            if( this.verNoticeInfo.checked02 === false){
                this.isChecked = true;
                this.isAllSuccess()
            }else{
                this.isChecked = false;
                this.isAllSuccess()
            }
        },
        verNoticeBox(){
            if (this.verNoticeInfo.checked08 === false || this.verNoticeInfo.checked09 === false || this.verNoticeInfo.checked10 === false){
                this.isCheckBox = true;
                this.isAllSuccess()
            }else{
                this.isCheckBox = false;
                this.isAllSuccess()
            }
        },

    }
}



// WEBPACK FOOTER //
// ./src/view/components/stepDescription7000.vue